import type { Post } from '@/@types/post'
import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'
import Avatar from '../../Avatar'

export interface PostCardProps extends HTMLAttributes<HTMLDivElement> {
	data: Post | undefined
}

export default function PostCard({ data, ...props }: PostCardProps) {
	return (
		<div
			css={css`
				display: grid;
				gap: 10px;
				background-color: var(--bg-on-body-2);
				padding: 10px;
				border-radius: 10px;
			`}
			{...props}
		>
			<main
				css={css`
					display: grid;
					grid-template-columns: auto 1fr;
					overflow: hidden;
					grid-gap: 10px;
				`}
			>
				<Avatar
					data={data?.user}
					css={css`
						margin: 4px 0;

						.jk-avatar {
							border-radius: 4px;
						}
					`}
				/>
				<div
					css={css`
						font-size: 16px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						line-height: 24px;
					`}
				>
					{data?.user?.screenName}:{data?.content ?? ''}
				</div>
			</main>
			{data?.topic?.content && (
				<footer
					css={css`
						box-shadow: 0 -0.5px 0 0 var(--tint-separator);
						font-weight: 500;
						text-align: right;
						font-size: 12px;
						color: var(--tint-secondary);
						padding-top: 5px;
					`}
				>
					{data?.topic?.content}
				</footer>
			)}
		</div>
	)
}
